module.exports = __webpack_public_path__ + "assets/raphael.818c937f.svg";